export default __webpack_public_path__ + "static/media/gallery_03.e4dcc605.jpg";